/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Reliability_FailedInputs */

const en_measure_reliability_failed = /** @type {(inputs: Measure_Reliability_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const zh_hans1_measure_reliability_failed = /** @type {(inputs: Measure_Reliability_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败`)
};

const pt_br2_measure_reliability_failed = /** @type {(inputs: Measure_Reliability_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falhou`)
};

const es_measure_reliability_failed = /** @type {(inputs: Measure_Reliability_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallidas`)
};

const fr_measure_reliability_failed = /** @type {(inputs: Measure_Reliability_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec`)
};

const de_measure_reliability_failed = /** @type {(inputs: Measure_Reliability_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

const ru_measure_reliability_failed = /** @type {(inputs: Measure_Reliability_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неудачно`)
};

const it_measure_reliability_failed = /** @type {(inputs: Measure_Reliability_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallite`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Measure_Reliability_FailedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_reliability_failed = /** @type {((inputs?: Measure_Reliability_FailedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Reliability_FailedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_reliability_failed(inputs)
	if (locale === "pt-BR") return pt_br2_measure_reliability_failed(inputs)
	if (locale === "es") return es_measure_reliability_failed(inputs)
	if (locale === "fr") return fr_measure_reliability_failed(inputs)
	if (locale === "de") return de_measure_reliability_failed(inputs)
	if (locale === "ru") return ru_measure_reliability_failed(inputs)
	if (locale === "it") return it_measure_reliability_failed(inputs)
	return en_measure_reliability_failed(inputs)
});